import UI from "@components/Home/Favourites/Tile/UI";
import { Playlist as PlaylistType } from "@libs/wire";

const Playlist = ({ playlist }: { playlist: PlaylistType }) => {
  return (
    <UI
      title={playlist.title}
      images={playlist.images}
      href={{
        pathname: "/(app)/(tabs)/explore/[collectionType]/[collectionId]",
        params: {
          collectionType: "playlist",
          collectionId: playlist.id,
        },
      }}
    />
  );
};

export default Playlist;
